<template>

  <b-container fluid class="p-row">
    <m-posts-400 :paginate="true" :category-panel="true" class="mt-5"/>
  </b-container>


</template>

<script>

export default {
  name: "Posts",
}
</script>

<style scoped>
.p-row {
  margin-top: 30px;
}
</style>